import React, { useEffect, useRef, useState } from "react";
import SystemLocationTabs from "./SystemLocationTabs";
import AddUpdateInstruction from "./AddUpdateInstruction";
import {
  Button,
  Col,
  Container,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import AccordionComponent from "../../../../common/Accordion";
import SearchableAddressDropdown from "../../../../common/SearchableZipDropdown";
import TextInput from "../../../../common/PicklistTesxBox";
import { searchManualZipCode } from "../../../../services/StakeholderApi";
import TagComponent from "../../../../common/TagComponent";
import {
  addMedicareLocation,
  GetMedicareLocationData,
  GetSpecialInstructionData,
  updateMedicareLocation,
} from "../../../../services/SystemLocationAPI";
import { validateMedicareAddress } from "../actions/systemMedicareValidation";
import Loader from "../../../../common/Loader";
import Snackbar from "../../../../common/Snackbar";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import DataTable from "../../../../common/DataTable";
import { MEDICARE_LOGS } from "../actions/constant";
import moment from "moment";
import { PICKLIST_GROUP_NAME } from "../../../../common/Constant";
import { fetchPickListByGroupName } from "../../../../services/CaseInformationApi";
import MapForLocation from "./MapForLocation";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import SearchAutosuggest from "../../../../common/SearchAutosuggestLocations";
import { normalizeCountry, normalizeState } from "../../../../utils/normalizer";
import { getPlaceByAddress } from "../../../../utils/getPlaceByAddress";
import { isValidCoordinate } from "../../../../utils/validators";

interface HospitalClinicSearchResult {
  areaName: string;
  districtName: string;
  localeName: string;
  physicalCity: string;
  physicalState: string;
  county: string;
  physicalZip: string;
  country: string;
}

const AddUpdateMedicareLocation: React.FC<any> = ({
  onCancel,
  selectedLocation,
}) => {
  const userID = useSelector((state: RootState) => state.auth.userid);
  const [selectedTab, setSelectedTab] = useState("Details");

  const [locationID, setLocationID] = useState("");
  const [manualLocation, setManualLocation] = useState("");
  const [manualAddress, setManualAddress] = useState("");
  const [manualCity, setManualCity] = useState("");
  const [manualState, setManualState] = useState("");
  const [manualCounty, setManualCounty] = useState("");
  const [manualCountry, setManualCountry] = useState("");
  const [manualZip, setManualZip] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  const [cityOptions, setCityOptions] = useState<string[]>([]);
  const [stateOptions, setStateOptions] = useState<string[]>([]);
  const [countyOptions, setCountyOptions] = useState<string[]>([]);
  const [countryOptions, setCountryOptions] = useState<string[]>([]);
  const [zipOptions, setZipOptions] = useState<string[]>([]);

  const [isActive, setIsActive] = useState<boolean>(true);
  const [showMap, setShowMap] = useState<boolean>(false);

  const [emailId, setEmailId] = useState<string[]>([]);
  const [phoneNumber, setPhoneNumber] = useState<string[]>([]);
  const [faxNumber, setFaxNumber] = useState<string[]>([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [showDrawer, setShowDrawer] = useState(false);
  const [medicareData, setMedicareData] = useState<any>(null);
  const [clinicLogs, setClinicLogs] = useState<any[]>([]);
  const [showTooltip, setShowTooltip] = useState(false);

  const [instructionData, setInstructionData] = useState<any>(null);
  const [instructionOption, setInstructionOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [regionOption, setRegionOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [region, setRegion] = useState<string | number | null>(null);
  const [contact, setContact] = useState("");
  const [locations, setLocations] = useState<any[]>([]);
  const [isManualLocation, setIsManualLocation] = useState(false);
  const [isCounty, setIsCounty] = useState(false);
  const isAutoFilledRef = useRef(false);
  const [suggestionSelected, setSuggestionSelected] = useState(false);
  const [suggestionFilled, setSuggestionFilled] = useState({ city: false, county: false, state: false, country: false, zip: false });

  const params = {
    location: {
      groupName: PICKLIST_GROUP_NAME.Location_SplInstructions,
      triggerById: userID,
    },
    region: {
      groupName: PICKLIST_GROUP_NAME.Region_List,
      triggerById: userID,
    },
  };

  const fetchCategoryData = async () => {
    try {
      const categoryData = await fetchPickListByGroupName(params.location);

      setInstructionOption(categoryData);

      const regionData = await fetchPickListByGroupName(params.region);

      setRegionOption(regionData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getMedicareLocationData = async () => {
    const locationData = await GetMedicareLocationData(
      locationID ? locationID : selectedLocation,
    );
    if (locationData) {
      setMedicareData(locationData);
      setLocationID(locationData?.medicareId);
      setRegion(Number(locationData?.regionId));
      setManualLocation(locationData?.providerName);
      setManualAddress(locationData?.providerAddress);
      setManualCity(locationData?.physicalCity);
      setManualState(locationData?.physicalState);
      setManualCounty(locationData?.county);
      setManualCountry(locationData?.countryName);
      setManualZip(locationData?.physicalZip);
      setLatitude(locationData?.latitude);
      setLongitude(locationData?.longitude);
      setEmailId(
        locationData.emailId
          ? locationData.emailId.split(",").map((num: string) => num.trim())
          : [],
      );
      setContact(locationData?.contactName);
      setPhoneNumber(
        locationData.telephoneNumber
          ? locationData.telephoneNumber
              .split(",")
              .map((num: string) => num.trim())
          : [],
      );
      setFaxNumber(
        locationData.faxNumber
          ? locationData.faxNumber.split(",").map((num: string) => num.trim())
          : [],
      );

      setCityOptions([locationData?.physicalCity].filter(Boolean));
      setStateOptions([locationData?.physicalState].filter(Boolean));
      setCountryOptions([locationData?.countryName].filter(Boolean));
      setZipOptions([locationData?.physicalZip].filter(Boolean));

      // ✅ Also push this record into searchResults so filtering logic works
      setSearchResults([locationData]);

      const newLocation: any = {
        locationname: locationData?.providerName || "NA",
        locationaddress: locationData?.providerAddress || "NA",
        latitude: locationData?.latitude ?? null,
        longitude: locationData?.longitude ?? null,
      };
      //setLocations([newLocation]);
    }
  };

  const getSpecialiInstructionData = async () => {
    if (locationID) {
      const instructionData = await GetSpecialInstructionData(locationID);
      if (instructionData) {
        setInstructionData(instructionData);
      }
    }
  };

  const getSpecialiInstructionDataNew = async (id: any) => {
    if (id) {
      const instructionData = await GetSpecialInstructionData(id);
      if (instructionData) {
        setInstructionData(instructionData);
      }
    }
  };

  useEffect(() => {
    if (userID) fetchCategoryData();
  }, [userID]);

  useEffect(() => {
    if (locationID) {
      getSpecialiInstructionData();
      getMedicareLocationData();
    }
  }, [locationID]);

  useEffect(() => {
    if (selectedLocation) getMedicareLocationData();
  }, [selectedLocation]);

  const [searchResults, setSearchResults] = useState<
    HospitalClinicSearchResult[]
  >([]);

  const handleSearch = async (query: string) => {
    try {
      // Optional: setLoading(true);

      const response = await searchManualZipCode({
        SearchString: query,
        pageNo: 0,
        pageSize: 0,
        sortColumn: "",
        sortOrder: "",
      });

      const results: HospitalClinicSearchResult[] = response?.result || [];

      if (results.length > 0) {
        setSearchResults(results);

        const cities = [
          ...new Set(results.map((r) => r.physicalCity).filter(Boolean)),
        ];
        const zips = [
          ...new Set(results.map((r) => r.physicalZip).filter(Boolean)),
        ];
        const states = [
          ...new Set(results.map((r) => r.physicalState).filter(Boolean)),
        ];
        const county = [
          ...new Set(results.map((r) => r.county).filter(Boolean)),
        ];
        const countries = [
          ...new Set(results.map((r) => r.country).filter(Boolean)),
        ];

        setCityOptions(cities);
        setZipOptions(zips);
        setStateOptions(states);
        setCountyOptions(county);
        setCountryOptions(countries);

        // Clear only if selected value is no longer valid
        if (!cities.includes(manualCity)) setManualCity("");
        if (!zips.includes(manualZip)) setManualZip("");
        if (!states.includes(manualState)) setManualState("");
        if (!county.includes(manualCounty)) setManualCounty("");
        if (!countries.includes(manualCountry)) setManualCountry("");
      }
    } catch (error) {
      console.error("Error searching clinic data:", error);
    } finally {
      // Optional: setLoading(false);
    }
  };

  const handleSearchCounty = async (query: string) => {
    try {
      // Optional: setLoading(true);

      const response = await searchManualZipCode({
        SearchString: query,
        pageNo: 0,
        pageSize: 0,
        sortColumn: "",
        sortOrder: "",
      });

      const results: HospitalClinicSearchResult[] = response?.result || [];

      if (results.length > 0) {
        const county = [
          ...new Set(results.map((r) => r.county).filter(Boolean)),
        ];
        setCountyOptions(county);

        // Clear only if selected value is no longer valid
        if (!county.includes(manualCounty)) setManualCounty("");
      }
    } catch (error) {
      console.error("Error searching clinic data:", error);
    } finally {
      // Optional: setLoading(false);
    }
  };

  // Update dropdown options from unfiltered searchResults
  useEffect(() => {
    const cities = [
      ...new Set(searchResults.map((r) => r.physicalCity).filter(Boolean)),
    ];
    const states = [
      ...new Set(searchResults.map((r) => r.physicalState).filter(Boolean)),
    ];
    const county = [
      ...new Set(searchResults.map((r) => r.county).filter(Boolean)),
    ];

    const countries = [
      ...new Set(searchResults.map((r) => r.country).filter(Boolean)),
    ];
    const zips = [
      ...new Set(searchResults.map((r) => r.physicalZip).filter(Boolean)),
    ];

    setCityOptions(cities);
    setStateOptions(states);
    setCountyOptions(county);
    setCountryOptions(countries);
    setZipOptions(zips);
  }, [searchResults]);

  useEffect(() => {
    if (!manualCity && !manualZip) return;

    let filtered = [...searchResults];

    if (manualCity?.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.physicalCity?.toLowerCase() === manualCity.trim().toLowerCase(),
      );
    }

    if (manualZip?.trim()) {
      filtered = filtered.filter(
        (item) =>
          item.physicalZip?.toLowerCase() === manualZip.trim().toLowerCase(),
      );
    }

    const cities = [
      ...new Set(filtered.map((r) => r.physicalCity).filter(Boolean)),
    ];
    const zips = [
      ...new Set(filtered.map((r) => r.physicalZip).filter(Boolean)),
    ];
    const states = [
      ...new Set(filtered.map((r) => r.physicalState).filter(Boolean)),
    ];
    const county = [...new Set(filtered.map((r) => r.county).filter(Boolean))];
    const countries = [
      ...new Set(filtered.map((r) => r.country).filter(Boolean)),
    ];

    setCityOptions(cities);
    setZipOptions(zips);
    setStateOptions(states);
    setCountyOptions(county);
    setCountryOptions(countries);

    if (cities.length === 1 && !manualCity) setManualCity(cities[0]);
    if (zips.length === 1 && !manualZip) setManualZip(zips[0]);
    if (states.length === 1 && !manualState) setManualState(states[0]);
    if (county.length === 1 && !manualCounty) setManualCounty(county[0]);
    if (countries.length === 1 && !manualCountry)
      setManualCountry(countries[0]);
  }, [manualCity, manualZip, searchResults]);

  const [locationDetailsKey, setLocationDetailsKey] = useState<string | null>(
    "0",
  );

  const [viewMapKey, setViewMapKey] = useState<string | null>("0");

  const [communicationDetailSubKey, setcommunicationDetailSubKey] = useState<
    string | null
  >("0");

  const locationdetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={locationDetailsKey}
      onSelect={(key) => setLocationDetailsKey(key as string)}
    />
  );

  const viewMapAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={viewMapKey}
      onSelect={(key) => setViewMapKey(key as string)}
    />
  );

  const communicationDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={communicationDetailSubKey}
      onSelect={(key) => setcommunicationDetailSubKey(key as string)}
    />
  );

  const validateClinicForm = () => {
    const validationErrors = validateMedicareAddress(
      manualAddress,
      manualLocation,
      manualCity,
      manualCountry,
      manualState,
      manualZip,
      emailId,
      phoneNumber,
      faxNumber,
    );

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    if (validateClinicForm()) {
      setLoading(true);
      try {
        let fixedLoc: { latitude?: number | null; longitude?: number | null } =
          {};

        if (latitude && longitude) {
          fixedLoc = {
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude),
          };
        } else {
          const addressInDetails = `${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
          const locationInDetails = `${manualLocation}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
          const locationFullDetails = `${manualLocation}, ${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;

          const placeResult = await getPlaceByAddress({
            name: locationInDetails,
            address: addressInDetails,
            fullAddress: locationFullDetails,
          });

          if (placeResult) {
            fixedLoc = {
              latitude: placeResult.latitude,
              longitude: placeResult.longitude,
            };
            setLatitude(
              placeResult.latitude ? String(placeResult.latitude) : "",
            );
            setLongitude(
              placeResult.longitude ? String(placeResult.longitude) : "",
            );
          }
        }

        let splInstructionsPayload: any[] = [];

        if (locationID) {
          // Use instructionData if location already exists
          splInstructionsPayload = instructionData.map((row: any) => ({
            SplInstructionID: row.splInstructionId,
            SplInstructionData: row.splInstructionData || "",
          }));
        } else {
          // Use instructionOption for new location
          splInstructionsPayload = instructionOption.map((opt: any) => ({
            SplInstructionID: opt.value,
            SplInstructionData: "",
          }));
        }
        const locationPayload = {
          medicareId: locationID ? locationID : 0,
          providerName: manualLocation,
          providerAddress: manualAddress,
          physicalCity: manualCity,
          physicalState: manualState,
          physicalZip: manualZip,
          telephoneNumber: phoneNumber.length > 0 ? phoneNumber.join(",") : "",
          faxNumber: faxNumber.length > 0 ? faxNumber.join(",") : "",
          emailId: emailId.length > 0 ? emailId.join(",") : "",
          countryName: manualCountry,
          providerType: "Medicare",
          latitude: isValidCoordinate(fixedLoc.latitude)
            ? String(fixedLoc.latitude)
            : "",
          longitude: isValidCoordinate(fixedLoc.longitude)
            ? String(fixedLoc.longitude)
            : "",
          county: manualCounty,
          splInstructions: splInstructionsPayload,
          contactName: contact,
          regionId: null,
          createdBy: userID,
        };

        const isUpdate = locationID ? true : false;

        const apiMethod = isUpdate
          ? updateMedicareLocation
          : addMedicareLocation;
        const response = await apiMethod(locationPayload);
        const successMessage = isUpdate
          ? "Location updated successfully."
          : "Location added successfully.";

        if (response.isSuccess) {
          setSnackbarMessage(successMessage);
          setError("success");
          setSnackbarOpen(true);
          // Auto-close after 3 seconds

          if (!locationID) {
            setLocationID(response?.result);
            // getMedicareLocationData();
            await getSpecialiInstructionDataNew(response?.result);
            setSnackbarOpen(false);
            setSelectedTab("Instruction");
          } else {
            setTimeout(() => {
              setSnackbarOpen(false);
              setSelectedTab("Instruction");
            }, 1000);
          }

          // Change tab after snackbar is already triggered
          // setTimeout(() => {
          //   setSnackbarOpen(false);
          //   setSelectedTab("Instruction");
          // }, 1000);
        } else if (response.isSuccess == false) {
          setSnackbarMessage("Location Already Exists");
          setError("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error while saving system location:", error);
        setSnackbarMessage("An unexpected error occurred.");
        setError("error");
        setSnackbarOpen(true);
      } finally {
        setLoading(false);
      }
    }
  };

  const handlePDFClick = () => {
    if (medicareData) {
      // Extract the four fields from the selectedContact
      setShowTooltip(false);

      const { createdByName, createdDate, modifiedByName, modifiedDate } =
        medicareData;

      // Format the date using moment.js
      const formattedCreatedDate =
        moment(createdDate).format("MM/DD/YYYY hh:mm A");
      const formattedModifiedDate =
        moment(modifiedDate).format("MM/DD/YYYY hh:mm A");

      // Set the values in the state
      setClinicLogs([
        {
          createdByName,
          createdDate: formattedCreatedDate, // Use formatted date
          modifiedByName,
          modifiedDate: formattedModifiedDate, // Use formatted date
        },
      ]);

      // Show the drawer
      setShowDrawer(true);
    }
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleAddressSuggestionSelect = async (suggestion: any) => {
    isAutoFilledRef.current = true;
    setIsManualLocation(false);
    setManualAddress(suggestion.providerAddress || "");
    setManualLocation(suggestion.providerName || "");
    setIsCounty(suggestion?.county ? false : true);
    const suggestedZip = suggestion.physicalZip || "";
    const newStateCode = normalizeState(suggestion.physicalState);
    const newCountryCode = normalizeCountry(suggestion.country || "USA");
    if (suggestion.physicalCity) setManualCity(suggestion.physicalCity);
    if (suggestion.physicalState) setManualState(newStateCode);
    if (suggestion.country) setManualCountry(newCountryCode);
    if (suggestion.county) setManualCounty(suggestion.county);
    setSuggestionSelected(true);
    setSuggestionFilled({
      city: !!suggestion.physicalCity,
      county: !!suggestion.county,
      state: !!suggestion.physicalState,
      country: !!suggestion.country,
      zip: !!suggestedZip,
    });
    if (suggestion.latitude) setLatitude(String(suggestion.latitude));
    if (suggestion.longitude) setLongitude(String(suggestion.longitude));
    if (suggestion.physicalCity) setCityOptions([suggestion.physicalCity]);
    if (newStateCode) setStateOptions([newStateCode]);
    if (newCountryCode) setCountryOptions([newCountryCode]);
    if (suggestion.county) setCountyOptions([suggestion.county]);

    if (suggestedZip) {
      setManualZip(suggestedZip);
      setZipOptions([suggestedZip]);
      try {
        const response = await searchManualZipCode({
          SearchString: suggestedZip,
          pageNo: 0,
          pageSize: 10,
          sortColumn: "",
          sortOrder: "",
        });

        const results = response?.result || [];

        if (results.length > 0) {
          const typedResults = results as HospitalClinicSearchResult[];
          const cities = [
            ...new Set(typedResults.map((r) => r.physicalCity).filter(Boolean)),
          ] as string[];
          const zips = [
            ...new Set(typedResults.map((r) => r.physicalZip).filter(Boolean)),
          ] as string[];
          const states = [
            ...new Set(
              typedResults.map((r) => r.physicalState).filter(Boolean),
            ),
          ] as string[];
          const countries = [
            ...new Set(typedResults.map((r) => r.country).filter(Boolean)),
          ] as string[];
          const counties = [
            ...new Set(typedResults.map((r) => r.county).filter(Boolean)),
          ] as string[];

          setCityOptions(cities);
          setZipOptions(zips);
          setStateOptions(states);
          setCountryOptions(countries);
          setCountyOptions(counties);
        }
      } catch (error) {
        console.error("Zip lookup failed, using suggestion values:", error);
      }
    }
  };

  const handleManualLocationAdd = () => {
    setIsManualLocation(true);
    setManualLocation("");
    setManualAddress("");
    setManualCity("");
    setManualState("");
    setManualZip("");
    setManualCountry("");
    setManualCounty("");
    setLocations([]);
    setShowMap(false);
    setLatitude("");
    setLongitude("");
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, county: false, state: false, country: false, zip: false });
  };

  const viewMap = async () => {
    setLoading(true);
    setShowMap(true);
    try {
      const addressInDetails = `${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
      const locationInDetails = `${manualLocation}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;
      const locationFullDetails = `${manualLocation}, ${manualAddress}, ${manualCity}, ${manualState}, ${manualZip}, ${manualCountry}`;

      let manualLatitude: any = latitude;
      let manualLongitude: any = longitude;

      if (!latitude || !longitude) {
        const placeResult = await getPlaceByAddress({
          name: locationInDetails,
          address: addressInDetails,
          fullAddress: locationFullDetails,
        });
        manualLatitude = placeResult?.latitude ?? null;
        manualLongitude = placeResult?.longitude ?? null;
      }

      const newLocation: any = {
        locationname: manualLocation?.trim() || "NA",
        locationaddress: addressInDetails?.trim() || "NA",
        latitude: manualLatitude,
        longitude: manualLongitude,
      };

      setLocations([newLocation]);
    } catch (error) {
      console.error("Error fetching coordinates:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAutoFilledRef.current) {
      isAutoFilledRef.current = false;
      return;
    }
    setSuggestionSelected(false);
    setSuggestionFilled({ city: false, county: false, state: false, country: false, zip: false });
    setManualCity("");
    setManualState("");
    setManualZip("");
    setManualCountry("");
    setManualCounty("");
    setLocations([]);
    setShowMap(false);
    setLatitude("");
    setLongitude("");
  }, [manualLocation?.trim(), manualAddress?.trim()]);

  useEffect(() => {
    setLocations([]);
    setShowMap(false);
    setLatitude("");
    setLongitude("");
  }, [manualCity, manualState, manualZip, manualCountry, manualCounty]);

  const locationFullDetailsForMap = [
    manualLocation,
    manualAddress,
    manualCity,
    manualState,
    manualZip,
    manualCountry,
  ]?.every((field) => field && field?.trim() !== "");

  return (
    <div>
      <Loader isLoading={loading} />
      <SystemLocationTabs
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        enabledTabs={locationID ? ["Details", "Instruction"] : ["Details"]}
      />
      {selectedTab === "Details" && (
        <>
          <Container fluid className="px-5">
            <Snackbar
              open={snackbarOpen}
              message={snackbarMessage}
              onClose={() => setSnackbarOpen(false)}
              severity={error}
            />
            {locationdetailAccordion([
              {
                title: "Location Details",
                content: (
                  <>
                    <Row className="row mb-3">
                      <Col md={3}>
                        <TextInput
                          label="Location ID"
                          name="LocationID"
                          value={locationID}
                          onChange={(e) => setLocationID(e.target.value)}
                          maxLength={100}
                          required
                          disabled
                        />
                      </Col>
                      {/* <Col sm={3} className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="Region"
                          name="regionID"
                          required
                          options={regionOption}
                          value={region}
                          onChange={(e, name, value) => setRegion(value)}
                        />
                      </Col> */}
                      <Col md={9}>
                        {!isManualLocation ? (
                          <SearchAutosuggest
                            value={manualLocation}
                            onChange={setManualLocation}
                            onSuggestionSelect={handleAddressSuggestionSelect}
                            onManualLocationAdd={handleManualLocationAdd}
                            enableManualLocation={true}
                            label="Location"
                            required
                            apiKey={
                              process.env
                                .REACT_APP_GOOGLE_PLACES_AUTOCOMPLETE_API_KEY
                            }
                            countryRestriction="us"
                            sortingLocation="Location"
                            maxLength={100}
                          />
                        ) : (
                          <TextInput
                            label="Location"
                            name="Location"
                            value={manualLocation}
                            onChange={(e) => setManualLocation(e.target.value)}
                            maxLength={100}
                            required
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className="row mb-3">
                      <Col md={12}>
                          <TextInput
                            label="Address Line 1"
                            name="Address Line 1"
                            value={manualAddress}
                            onChange={(e) => setManualAddress(e.target.value)}
                            maxLength={100}
                            required
                          />
                      </Col>
                    </Row>
                    <Row className="mb-3 mt-3 loc-details">
                      <Col md={3}>
                        <SearchableAddressDropdown
                          label="City"
                          value={manualCity || ""}
                          options={cityOptions}
                          onSearch={handleSearch}
                          onSelect={(val) => setManualCity(val)}
                          required={true}
                          disabled={!isManualLocation && (!suggestionSelected || suggestionFilled.city)}
                        />
                      </Col>
                      <Col md={3}>
                        <SearchableAddressDropdown
                          label="County"
                          value={manualCounty || ""}
                          options={countyOptions}
                          onSearch={handleSearchCounty}
                          onSelect={(val) => setManualCounty(val)}
                          disabled={
                            !isManualLocation && (!suggestionSelected || suggestionFilled.county)
                          }
                        />
                      </Col>
                      <Col md={3}>
                        <SearchableAddressDropdown
                          label="State"
                          value={manualState || ""}
                          options={stateOptions}
                          onSearch={handleSearch}
                          onSelect={(val) => setManualState(val)}
                          required={true}
                          disabled={!isManualLocation && (!suggestionSelected || suggestionFilled.state)}
                        />
                      </Col>
                      <Col md={3}>
                        <SearchableAddressDropdown
                          label="Country"
                          value={manualCountry}
                          options={countryOptions}
                          onSearch={handleSearch}
                          onSelect={(val) => setManualCountry(val)}
                          required={true}
                          disabled={!isManualLocation && (!suggestionSelected || suggestionFilled.country)}
                        />
                      </Col>
                      <Col md={3} className="mt-3">
                        <SearchableAddressDropdown
                          label="Zip"
                          value={manualZip}
                          options={zipOptions}
                          onSearch={handleSearch}
                          onSelect={(val) => setManualZip(val)}
                          required={true}
                          disabled={!isManualLocation && (!suggestionSelected || suggestionFilled.zip)}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3 mb-3">
                      {locationFullDetailsForMap && (
                        <Col sm={12} className="d-flex justify-content-end">
                          <Button
                            variant="outline-primary"
                            className="d-flex align-items-center"
                            onClick={viewMap}
                          >
                            <span className="material-symbols-outlined me-1">
                              <img
                                src="/map.png"
                                alt="map"
                                style={{ width: "27px", height: "23px" }}
                              />
                            </span>
                            View in Map
                          </Button>
                        </Col>
                      )}
                    </Row>
                    {showMap && locationFullDetailsForMap
                      ? viewMapAccordion([
                          {
                            title: "Map Details",
                            content: (
                              <>
                                {locations[0]?.latitude != null ? (
                                  <MapForLocation
                                    locations={locations}
                                    onLocationSelect={
                                      handleAddressSuggestionSelect
                                    }
                                  />
                                ) : (
                                  <div className="text-center py-4 no_rec_data">
                                    No Location Found
                                  </div>
                                )}
                              </>
                            ),
                          },
                        ])
                      : null}

                    <Row className="mt-2">
                      <div className="col-md-3">
                        <div className="form-check p-2 py-2">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="Isactive"
                            name="Isactive"
                            checked={isActive}
                            onChange={(e) => setIsActive(e.target.checked)}
                            style={{ cursor: "pointer" }}
                          />
                          <label className="form-check-label">Is Active?</label>
                          <span className="ms-2 fw-bold">
                            {isActive ? "Yes" : "No"}
                          </span>
                        </div>
                      </div>
                    </Row>
                    {communicationDetailSubAccordion([
                      {
                        title: "Additional Communication Details",
                        content: (
                          <>
                            <Row>
                              <Col md={4}>
                                <TextInput
                                  label="Contact Name"
                                  name="Contact Name"
                                  value={contact}
                                  onChange={(e) => setContact(e.target.value)}
                                  maxLength={100}
                                />
                              </Col>
                              <Col sm={4}>
                                <TagComponent
                                  label="Email Address"
                                  value={emailId}
                                  onChange={setEmailId}
                                />
                              </Col>
                              <Col sm={4}>
                                <TagComponent
                                  label="Phone Number"
                                  value={phoneNumber}
                                  onChange={(newValues) =>
                                    setPhoneNumber(newValues.map(String))
                                  }
                                  isPhoneOrFax={true}
                                />
                              </Col>
                              {/* <Col sm={4} className="mt-3">
                                <TagComponent
                                  label="Fax No"
                                  value={faxNumber}
                                  onChange={(newValues) =>
                                    setFaxNumber(newValues.map(String))
                                  }
                                  isPhoneOrFax={true}
                                />
                              </Col> */}
                            </Row>
                          </>
                        ),
                      },
                    ])}
                  </>
                ),
              },
            ])}
            <Row className="mb-5">
              <Col sm={6} className="d-flex justify-content-start">
                {locationID ? (
                  <OverlayTrigger
                    show={showTooltip}
                    placement="auto"
                    trigger={["hover", "focus"]} // Important to prevent sticky tooltip
                    delay={{ show: 200, hide: 100 }}
                    overlay={
                      <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                        Logs
                      </Tooltip>
                    }
                  >
                    <Button
                      type="button"
                      className="btn btn-primary d-flex align-items-center mx-2"
                      onClick={handlePDFClick}
                      onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      <span className="material-icons">description</span>
                    </Button>
                  </OverlayTrigger>
                ) : null}
                <button
                  className="btn d-flex align-items-center btn-text-border me-2"
                  onClick={handleCancel}
                >
                  <span className="material-icons">arrow_back</span>Back
                </button>
              </Col>

              <Col sm={6} className="d-flex  justify-content-end">
                <Button
                  variant="outline-info"
                  className="d-flex align-items-center"
                  onClick={handleCancel}
                >
                  <span className="material-icons mr-2">close</span>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  className="ms-3 d-flex align-items-center"
                  // disabled={!isEditable || !formik.dirty || formik.isSubmitting}
                  onClick={handleSave}
                >
                  <span className="material-icons mx-1">save</span>Save
                </Button>
              </Col>
              <OverlayDrawer
                title={"Logs"}
                open={showDrawer}
                onClose={handleCloseDrawer}
                placement="bottom"
              >
                <DataTable
                  headers={MEDICARE_LOGS}
                  rows={clinicLogs}
                  isLogTable={true}
                />
              </OverlayDrawer>
            </Row>
          </Container>
        </>
      )}

      {selectedTab === "Instruction" && (
        <AddUpdateInstruction
          instructionData={instructionData}
          instructionOption={instructionOption}
          locationID={locationID}
          medicareData={medicareData}
          setSelectedTab={setSelectedTab}
          onCancel={handleCancel}
          getMedicareLocationData={getMedicareLocationData} // ✅ Pass as prop
        />
      )}
    </div>
  );
};

export default AddUpdateMedicareLocation;
